import { useMemo } from 'react';
import { cidrToRange } from '../../apps/cidr-planner/cidrUtils';
import type { CidrBlock, IpCountMode } from '../../apps/cidr-planner/types';
import type { DisplayLang } from '../../../shared/utils/pageDisplay';
import { CidrSheet } from './CidrSheet';
import { NSplitFields } from './NSplitFields';

type BlockSplitDialogProps = {
  block: CidrBlock;
  ipCountMode: IpCountMode;
  lang: DisplayLang;
  onClose: () => void;
  onSplit: (payloads: Array<{ cidr: string; name: string }>) => void;
};

const TEXT = {
  ja: {
    title: 'ブロックを分割',
    target: (cidr: string) => `対象: ${cidr}`,
    cancel: 'キャンセル',
    close: '閉じる',
  },
  en: {
    title: 'Split block',
    target: (cidr: string) => `Target: ${cidr}`,
    cancel: 'Cancel',
    close: 'Close',
  },
} as const;

export function BlockSplitDialog({
  block,
  ipCountMode,
  lang,
  onClose,
  onSplit,
}: BlockSplitDialogProps) {
  const t = TEXT[lang];
  const range = useMemo(() => cidrToRange(block.cidr), [block.cidr]);

  return (
    <CidrSheet title={t.title} closeLabel={t.close} onClose={onClose}>
      <p className="cidr-sheet__hint cidr-sheet__hint--strong">{t.target(block.cidr)}</p>
      <NSplitFields
        range={range}
        ipCountMode={ipCountMode}
        lang={lang}
        initialName={block.name}
        onSplit={onSplit}
      />
      <div className="cidr-sheet__actions">
        <button type="button" className="cidr-sheet__btn" onClick={onClose}>
          {t.cancel}
        </button>
      </div>
    </CidrSheet>
  );
}
